/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faTwitter,
  faFacebook,
  faInstagram,
  faLinkedin,
} from '@fortawesome/free-brands-svg-icons';

function Contact() {
  return (
    <div className="bg-sky-50 relative flex flex-wrap xl:mx-24 lg:m-16 md:m-8 m-4">
      <div className="w-full">
        <div className="h-2/4 w-1/4 border-t-8 border-transparent absolute top-0 left-0">
          {' '}
        </div>
        <div className="h-2/4 w-2/4 border-t-8 border-sky-400 absolute top-0 left-1/4">
          {' '}
        </div>
        <div className="h-2/4 w-1/4 border-t-8 border-blue-700 absolute top-0 right-0">
          {' '}
        </div>
      </div>
      <div className="md:w-1/2 w-full my-2 lg:p-16 md:p-8 p-4 pr-0">
        <h2 className="font-semibold text-md text-gray-700">ADDRESS</h2>
        <h3 className="font-bold md:text-xl text-md my-1">Entebbe International Airport</h3>
        <h3 className="font-bold md:text-xl text-md my-1">Tower Complex</h3>
        <h3 className="font-bold md:text-xl text-md my-1">P.O. Box 5536, Kampala</h3>
        <ul className="flex justify-start gap-8 mt-2 md:text-3xl text-xl pl-4 text-gray-600">
          <li>
            <a
              href="https://twitter.com/UgandaCAA"
              target="_blank"
              rel="noreferrer"
              aria-label="Twitter"
            >
              <FontAwesomeIcon icon={faTwitter} />
            </a>
          </li>
          <li>
            <a
              href="https://www.facebook.com/Ugandacaa/"
              target="_blank"
              rel="noreferrer"
              aria-label="Facebook"
            >
              <FontAwesomeIcon icon={faFacebook} />
            </a>
          </li>
          <li>
            <a
              href="https://www.instagram.com/ugandacaa/?hl=en"
              target="_blank"
              rel="noreferrer"
              aria-label="Instagram"
            >
              <FontAwesomeIcon icon={faInstagram} />
            </a>
          </li>
          <li>
            <a
              href="https://ug.linkedin.com/company/uganda-civil-aviation-authority"
              target="_blank"
              rel="noreferrer"
              aria-label="Linkedin"
            >
              <FontAwesomeIcon icon={faLinkedin} />
            </a>
          </li>
        </ul>
      </div>
      <div className="md:w-1/2 w-full my-2 md:pl-0 lg:p-16 md:p-8 px-4">
        <h2 className="font-semibold text-md text-gray-700">CONTACT US</h2>
        <h3 className="font-bold md:text-xl text-md my-2">Email: sms_dans@caa.co.ug</h3>
        <ul className="text-gray-600 text-sm my-3">
          <li>
            SMS Office: +256 414 352550, +256 312 352551, +256 312 352552, +256
            312 352553
          </li>
          <li className="mt-2">Fax: +256 414 321401, +256 414 320964</li>
        </ul>
      </div>
    </div>
  );
}

export default Contact;
